import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, UncontrolledTooltip } from 'reactstrap';

import moment from 'moment';

const fieldTypeWidths = {
    'text': 300,
    'number': 100,
    'boolean': 70,
    'date': 200,
    'time': 100,
    'currency': 150,
    's3file': 100
};
class ReportsTable extends Component {
    constructor(props) {
        super(props);
        this.sidebarScroll = React.createRef();
        this.contentScroll = React.createRef();
        this._preventEvent = false;
        this.contentLastScrollTop = 0;
        this.contentLastScrollLeft = 0;
        this.state = {
            hoverIndex: null,
            lastCheckedIndex: null,
            hoverColumnActive: null,
            columnMetadata: [],
            interval: null
        };
    }

    componentDidMount() {
        const { columns, defaultSort, sortDirection } = this.props;
        this.dragImg = new Image(0, 0);
        this.dragImg.src =
            'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

        if (defaultSort) {
            if (sortDirection && sortDirection == 'desc') {
                this.props.sortData(columns.find((c) => c.key == defaultSort), false, true);

            } else {
                this.props.sortData(columns.find((c) => c.key == defaultSort), true, false);
            }
        }
    }

    onSidebarScroll = (e) => {
        if (this._preventEvent) {
            this._preventEvent = false;
            return;
        }

        this._preventEvent = true;
        this.contentScroll.current.scrollTop = e.target.scrollTop;
    };

    onContentScroll = (e) => {
        if (this._preventEvent) {
            this._preventEvent = false;
            return;
        }

        if (e.target.scrollTop !== this.contentLastScrollTop) {
            this._preventEvent = true;
            this.sidebarScroll.current.scrollTop = e.target.scrollTop;
            this.contentLastScrollTop = e.target.scrollTop;
        }
    };

    RowItem(meta, index) {
        const { columns, toggledColumns, rowSettings, checked, checkRow, onClick, readOnly, columnWidths, disableCheck, mainColumnActive } = this.props;
        const { hoverIndex, columnMetadata } = this.state;
        return (
            <div
                style={{ margin: 'auto 0' }}
                key={`row-${meta._id}-${index}`}
                className={`tableColumnRow ${hoverIndex == index ? 'hover' : ''}  ${onClick ? 'c-pointer' : ''}`}
            >
                {columns.map((c, i) => {
                    let value = '';
                    if (typeof meta[c.key] != 'undefined' && meta[c.key] != null) {
                        if (typeof meta[c.key] == 'boolean') {
                            value = meta[c.key] ? 'Yes' : 'No';
                        } else if (c.type == 'icon') {
                            value = <i className={`${meta[c.key]}`} />;
                        } else if (c.type == 'date') {
                            const dateStamp = meta[c.key];
                            value = dateStamp !== '' ? moment(meta[c.key]).format('MM/DD/YYYY') : '';
                        } else if (c.type == 'timestamp') {
                            const timeStamp = meta[c.key];
                            value = timeStamp && timeStamp !== '' ? moment(timeStamp).format('MM/DD/YYYY h:mm a') : '';
                        } else if (c.type == 'time') {
                            const today = moment().format('YYYY-MM-DD');
                            const valueTime = meta[c.key];
                            value =
                                valueTime && valueTime !== '' ? moment(`${today} ${valueTime}`).format('h:mm a') : '';
                        } else if (c.type == 'link') {
                            value = (
                                <a className="link" href={meta[c.key]} target="_blank">
                                    {meta[c.key]}
                                </a>
                            );
                        } else if (c.type == 'bool') {
                            value = meta[c.key] ? 'Yes' : 'No';
                        } else if (c.type == 'currency') {
                            const currency = parseFloat(meta[c.key]);

                            value = !isNaN(currency) ? `$${currency.toFixed(2)}` : `$${0}`;
                        } else if (c.type == 'status') {
                            value = meta[c.key].charAt(0).toUpperCase() + meta[c.key].slice(1);
                        } else {
                            value = meta[c.key];
                        }
                    }
                    return (
                        toggledColumns[c.key] && (
                            <div
                                className="tableColumnRowCell"
                                key={`cell-${c.key}-${index}`}
                                style={{
                                    width: c.width ? c.width : columnWidths && columnWidths[c.key] ? columnWidths[c.key] : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
                                    minWidth: c.width ? c.width : columnWidths && columnWidths[c.key] ? columnWidths[c.key] : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
                                    maxWidth: c.width ? c.width : columnWidths && columnWidths[c.key] ? columnWidths[c.key] : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180
                                }}
                                /* style={
                                    columnWidth && columnWidth[c.key] ? (
                                        { maxWidth: columnWidth[c.key], minWidth: columnWidth[c.key] }
                                    ) : (
                                        {}
                                    )
                                } */
                                onClick={() => {
                                    if (disableCheck ||
                                        (!disableCheck &&
                                            i > 0) && onClick) {
                                        onClick(meta._id);
                                    }
                                }}
                            >
                                {meta.icon && (
                                    <div className='mr-10'>
                                        <i className={`${meta.icon}`} />
                                    </div>
                                )}
                                <div
                                    className="text-truncate rowText"
                                >
                                    {value}
                                </div>
                            </div>
                        )
                    );
                })}
                {rowSettings && rowSettings.length > 0 &&
                    <div style={{
                        paddingRight: 15, width: 50,
                        minWidth: 50,
                        maxWidth: 50,
                        marginLeft: 'auto'
                    }}>
                        <div className='detailsContainer' style={{ marginLeft: 'auto', paddingRight: 60 }}>
                            <UncontrolledDropdown direction="left" inNavbar >
                                <DropdownToggle className="columnToggle" style={{ width: 30, height: 30 }}>
                                    <div className='icon'>
                                        <i className="las la-ellipsis-v" />
                                    </div>
                                </DropdownToggle>
                                <DropdownMenu className="columnDropdown" style={{ minWidth: 230 }}>
                                    <div className='ph-20'>
                                        {rowSettings.map((item, index) => {
                                            return (
                                                <div>
                                                    <DropdownItem
                                                        className={`moreViewsPopoverItemMenuItem`}
                                                        style={{ textTransform: 'capitalize', padding: '7px 10px' }}
                                                        onClick={() => {
                                                            item.onClick && item.onClick(meta._id);
                                                        }}
                                                    >

                                                        {item.label}
                                                    </DropdownItem>
                                                </div>
                                            )
                                        })}
                                    </div>

                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    </div>
                }
            </div>
        );
    }

    GridItem(meta, index) {
        const { rowSettings } = this.props;
        const { hoverIndex, columnMetadata } = this.state;
        return (
            <div
                key={`row-${meta._id}-${index}`}
                className="flex"
                style={{ border: '1px solid #D5D5D5', width: 'clamp(250px, 23%, 350px)', borderRadius: 5, height: 80, marginBottom: 20, marginRight: 20 }}
            >
                <div className='flex aic jcc' style={{ fontSize: 40, background: '#F5F6FA', minWidth: 60 }}>

                    {meta.icon ? (<i className={`${meta.icon}`} />) : <i className="las la-file-alt" />}
                </div>
                <Link to={meta.link ? meta.link : ''} >
                    <div className='flex column jcc p-10 black h-100'>
                        <h3>{meta.name}</h3>
                        <p className='text-trunc'>{meta.description}</p>
                    </div>
                </Link>
                <div className='ml-a p-10 pl-0'>
                    <div className='flex jcc c-pointer mb-10' onClick={() => {
                        this.props.favoriteReport(meta._id, !meta.favorited);
                    }}>{meta.favorited ? <i className='las la-star' style={{ color: '#ffd400' }}></i> : <i className='lar la-star'></i>}</div>

                    {rowSettings && rowSettings.length > 0 &&
                        <div>
                            <div className='detailsContainer' >
                                <UncontrolledDropdown direction="bottom" inNavbar >
                                    <DropdownToggle className="columnToggle" style={{ width: 30, height: 30 }}>
                                        <div className='icon'>
                                            <i className="las la-ellipsis-v" />
                                        </div>
                                    </DropdownToggle>
                                    <DropdownMenu className="columnDropdown" style={{ minWidth: 230 }}>
                                        <div className='ph-20'>
                                            {rowSettings.map((item, index) => {
                                                return (
                                                    <div>
                                                        <DropdownItem
                                                            className={`moreViewsPopoverItemMenuItem`}
                                                            style={{ textTransform: 'capitalize', padding: '7px 10px' }}
                                                            onClick={() => {
                                                                item.onClick && item.onClick(meta._id);
                                                            }}
                                                        >

                                                            {item.label}
                                                        </DropdownItem>
                                                    </div>
                                                )
                                            })}
                                        </div>

                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }

    shiftCheck = (id, index) => {
        const { data, checked, checkRow } = this.props;
        const keys = Object.keys(checked);
        var checkedLength = keys.length;

        if (checkedLength == 0) {
            for (var i = 0; i <= index; i++) {
                //console.log(i);

                checkRow(data[i]._id);
            }
            this.setState({ lastCheckedIndex: index });
        } else {
            let from = this.state.lastCheckedIndex > index ? index : this.state.lastCheckedIndex;
            let to = this.state.lastCheckedIndex < index ? index : this.state.lastCheckedIndex;

            if (keys.includes(id)) {
                for (var i = from; i <= to; i++) {
                    checked[data[i]._id] && checkRow(data[i]._id);
                }
            } else {
                for (var i = from; i <= to; i++) {
                    !checked[data[i]._id] && checkRow(data[i]._id);
                }
            }
            this.setState({ lastCheckedIndex: index });
        }
    };

    render() {
        const {
            toggledColumns,
            data,
            sortData,
            columns,
            classes,
            gridView
        } = this.props;
        const { columnMetadata } = this.state;
        const mainColumn = columns[0];

        return !gridView ? (
            <div className={`sectionTable ${classes ? classes : ''}`} style={this.props.style}>
                <div className="tableMainColumn noselect">
                    <div className="tableColumnHeader">
                        <div className="tableMainColumnCell">
                            <div
                                className="tableCellData"
                                onClick={() => {
                                    if (mainColumn.sortAsc) {
                                        sortData(mainColumn, false, true);
                                    } else {
                                        sortData(mainColumn, true, false);
                                    }
                                }}
                            >
                                <div className="tableColumnTitle2 pl-25">
                                    {mainColumn.label}

                                    {mainColumn.sortAsc ? (
                                        <i className="las la-angle-down" />
                                    ) : mainColumn.sortDesc ? (
                                        <i className="las la-angle-up" />
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="tableColumnRows hideScrollbar"
                        ref={this.sidebarScroll}
                        onScroll={this.onSidebarScroll}
                    >
                        {data.map((a, i) => {
                            return (
                                <div
                                    className={`tableMainColumnRowCell`}
                                    key={a._id}
                                >
                                    <div className='mr-10 c-pointer' onClick={() => {
                                        this.props.favoriteReport(a._id, !a.favorited);
                                    }}>{a.favorited ? <i className='las la-star' style={{ color: '#ffd400' }}></i> : <i className='lar la-star'></i>}</div>

                                    <Link to={a.link ? a.link : ''} className="tableCellData">
                                        <div className="tableRowText">{a[mainColumn.key]} </div>
                                        <i className="las la-angle-right ml-a" />
                                    </Link>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="tableSubColumns">
                    <div className="tableColumnHeader">
                        {columns.map(
                            (c, i) => {
                                const divRef = React.createRef();
                                //const dimensions = this.useRefDimensions(divRef)

                                return (
                                    !(mainColumn.key == c.key) && toggledColumns[c.key] && (
                                        <div
                                            ref={divRef}
                                            className="tableSubColumn"
                                            style={{
                                                width: columnMetadata[c.key] ? columnMetadata[c.key].width : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
                                                minWidth: columnMetadata[c.key] ? columnMetadata[c.key].width : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
                                                maxWidth: columnMetadata[c.key] ? columnMetadata[c.key].width : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180
                                            }}
                                            key={c.key}
                                            onClick={() => {
                                                if (c.sortAsc) {
                                                    sortData(c, false, true);
                                                } else {
                                                    sortData(c, true, false);
                                                }
                                            }}
                                        >
                                            <div className="tableColumnTitle2 flex-ac">
                                                <div
                                                    style={{
                                                        width: columnMetadata[c.key] ? columnMetadata[c.key].width : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
                                                        minWidth: columnMetadata[c.key] ? columnMetadata[c.key].width : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
                                                        maxWidth: columnMetadata[c.key] ? columnMetadata[c.key].width : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    }}><span id={`header${i}`}>{c.label}</span>
                                                    {c.sortAsc ? (
                                                        <i className="las la-angle-down" />
                                                    ) : c.sortDesc ? (
                                                        <i className="las la-angle-up" />
                                                    ) : (
                                                        ''
                                                    )}

                                                </div>
                                                <UncontrolledTooltip className="toooltip" placement="bottom" target={`header${i}`}>
                                                    {c.label}
                                                </UncontrolledTooltip>
                                            </div>

                                            <div className={'ml-a dragHandle'}
                                                draggable
                                                onDrag={async (evt) => {
                                                    //time
                                                    const currentTime = new Date().getTime();
                                                    //console.log(currentTime - lastUpdateDragTime)
                                                    /* if(currentTime - lastUpdateDragTime  > 5) {
                                                        lastUpdateDragTime = currentTime;
                                                    } else {
                                                        let editedColumnMetadata = columnMetadata;
                                                        let previousInitialWidth = columnMetadata[c.key].initialWidth;
                                                        let newWidth = previousInitialWidth + (evt.clientX - columnMetadata[c.key].initialPoint);
                                                        editedColumnMetadata[c.key].initialPoint = evt.clientX;
                                                        editedColumnMetadata[c.key].initialWidth = newWidth;
                                                        editedColumnMetadata[c.key].width = newWidth;
                                                        this.setState({ columnMetadata: editedColumnMetadata });
                                                    } */

                                                    let previousInitialWidth = columnMetadata[c.key].initialWidth;
                                                    let newWidth = previousInitialWidth + (evt.clientX - columnMetadata[c.key].initialPoint);
                                                    //update horizontal margin using style
                                                    if (evt.clientX > 0)
                                                        evt.target.style.marginRight = previousInitialWidth - newWidth + 'px';

                                                    //console.log(evt.target)

                                                }}
                                                onDragStart={(evt) => {
                                                    evt.dataTransfer.setDragImage(this.dragImg, 0, 0);

                                                    let editedColumnMetadata = columnMetadata;
                                                    if (editedColumnMetadata[c.key]) {
                                                        editedColumnMetadata[c.key].initialPoint = evt.clientX;
                                                    } else {
                                                        editedColumnMetadata[c.key] = { initialPoint: evt.clientX, initialWidth: 180 };
                                                    }

                                                    //columnMetadata = editedColumnMetadata;
                                                    this.setState({ columnMetadata: editedColumnMetadata });
                                                }}
                                                onDragEnd={(evt) => {
                                                    evt.target.style.marginRight = '0px';
                                                    let editedColumnMetadata = columnMetadata;
                                                    let previousInitialWidth = columnMetadata[c.key].initialWidth;
                                                    let newWidth = previousInitialWidth + (evt.clientX - columnMetadata[c.key].initialPoint);
                                                    editedColumnMetadata[c.key].initialPoint = evt.clientX;
                                                    editedColumnMetadata[c.key].initialWidth = newWidth;
                                                    editedColumnMetadata[c.key].width = newWidth;
                                                    console.log(newWidth)
                                                    //columnMetadata = editedColumnMetadata;
                                                    this.setState({ columnMetadata: editedColumnMetadata });
                                                }}
                                            >
                                                <i className="las la-arrows-alt-h nueHandle"></i>
                                            </div>
                                        </div>
                                    )

                                )
                            }
                        )}
                    </div>
                    <div className="tableColumnRows w-fc" ref={this.contentScroll} onScroll={this.onContentScroll}>
                        {data.map((d, i) => this.RowItem(d, i))}

                        {data.length == 0 ?

                            <div className='BlankTable'>
                                <h2 className='mb-15'> No {this.props.title} Yet</h2>

                                <p className='tableLabel'> Add <span className='lower' > {this.props.title} </span>{this.props.importAvailable && <span> or import <span className='lower'> {this.props.title} </span>  from a spreadsheet. </span>} </p>
                            </div>
                            : false
                        }
                    </div>
                </div>
            </div>
        ) : (<div className='reportsGrid'>

            <div className="w-100 flex wrap">
                {data.map((d, i) => this.GridItem(d, i))}
            </div>
        </div>);
    }
}

export default ReportsTable;
